import Paginacao from '@/core/store/default/paginacaoListagem'

export default {
	filtro: {
		processo: {},
		orgao: {
			id: null,
			sigla: null,
		},
		ano: null,
		idProcesso: null,
		idsFornecedores: [],
		numeroEditais: [],
		idsTipos: [],
		descricao: null,
		razaoSocial: null,
		numero: null,
		numeroEdital: null,
	},
	porFornecedor: {},
	paginacao: Paginacao(['razaoSocial']),
	edital: {
		filtro: {
			idProcesso: null,
			numeroEdital: null,
			idsFornecedores: [],
			numeroEditais: [],
			idsLotes: [],
		},
		paginacao: {
			rowsPerPage: 100,
		},
	},
}
